

<form [formGroup]="fileUploadForm" (ngSubmit)="onFormSubmit()">
    <input type="file" class="file-input"
       (change)="onFileSelect($event)" #fileUpload>

<div class="file-upload">
    <button color="primary" class="upload-btn mt-1"
    type="submit" >
        <mat-icon class="example-icon text-blue-500  cursor-pointer" aria-hidden="false" svgIcon="mat_solid:attach_file" (click)="fileUpload.click()"></mat-icon>
    </button>

</div>
    <!-- <div class="row">
        <div class="col-sm-6 text-center">

            <div class="custom-file">
                <input type="file" class="custom-file-input" id="customFile" name="myfile"
                    (change)="onFileSelect($event)">

                <label class="custom-file-label" for="customFile">{{fileInputLabel || 'Choose File'}}</label>
            </div>

        </div>
        <div class="col-sm-6 text-center">
            <button class="btn btn-primary" type="submit">Upload</button>
        </div>
    </div> -->
</form>